import { View as NbView } from 'native-base';

import { addWithConfig } from '../../utils';

export const View = NbView;

/** @deprecated nativebase component deprecated, use RN <View /> instead */
export default addWithConfig(View);
